/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'close': {
    width: 46,
    height: 46,
    viewBox: '0 0 46 46',
    data: `<defs><clipPath id="svgicon_close_a"><path pid="0" d="M0 0h46v46H0z"/></clipPath></defs><g clip-path="url(#svgicon_close_a)"><g _fill="none" _stroke="currentColor" stroke-width="1.5" transform="translate(1 1)"><circle pid="1" cx="22" cy="22" r="22" stroke-miterlimit="10"/><path pid="2" d="M11.043 11.043l21.883 21.883M32.926 11.043L11.043 32.926"/></g></g>`
  }
})
/* tslint:enable */
